import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
} from "react-router-dom";
import "./index.scss";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Host from "../../Components/Host";
import ReCAPTCHA from "react-google-recaptcha";
import {
  useFindOrderMutation,
  useVerifyMutation,
} from "../../services/track_order";
import OtpInput from "react-otp-input";
import Loader from "../../Components/Loader";
import HelmetComponent from "../../Components/HelmetComponent";
import { Tag } from "antd";
import IconButton from "@mui/joy/IconButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import Stepper from "@mui/joy/Stepper";
import Step, { stepClasses } from "@mui/joy/Step";
import StepIndicator, { stepIndicatorClasses } from "@mui/joy/StepIndicator";
import Typography, { typographyClasses } from "@mui/joy/Typography";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LocalMallIcon from "@mui/icons-material/LocalMall";

import { Box } from "@mui/material";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

var moment = require("moment");

function TrackOrder() {
  const { countryCode, languageCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  let fontFamilyForAll;
  if (languageCode === "ar") {
    fontFamilyForAll = "GessTwoMedium, sans-serif";
  } else {
    fontFamilyForAll = "Poppins, sans-serif";
  }
  const fontFamily = {
    fontFamily: fontFamilyForAll,
  };

  const [findorder, findresult] = useFindOrderMutation();
  const [verifyotp, verifyresult] = useVerifyMutation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm();
  const recaptchaRef = React.useRef();
  const [isOtpCard, setOtpCard] = useState(false);
  const [isLoginCard, setLoginCard] = useState(true);
  const [orderData, setorderData] = useState();
  const [otp, setOtp] = useState("");
  const [getToken, setToken] = useState("");

  async function loginWithOtp() {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    verifyotp({
      otp: otp,
      token: getToken,
      captcha_token: token,
      countryCode: countryCode,
      domain: Host?.domain,
      domainEmail: Host?.email,
    });
  }

  async function trackOrder(data) {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    findorder({
      order_number: data.order_number,
      email: data.email,
      captcha_token: token,
      countryCode: countryCode,
      domain: window.location.hostname || Host?.domain,
      domainEmail: Host?.email,
    });
  }

  useEffect(() => {
    if (findresult?.isSuccess) {
      setToken(findresult?.data?.token);
      setLoginCard(false);
      setOtpCard(true);
    }
    if (verifyresult?.isSuccess) {
      setorderData(verifyresult?.data?.order);
      setLoginCard(false);
      setOtpCard(false);
    }
    if (!verifyresult?.isSuccess) {
      if (!findresult?.isSuccess) {
        setLoginCard(true);
      }
    }
  }, [findresult, verifyresult]);

  function getDeliverydays(data, created) {
    if (Number(data) > 0) {
      return (
        <>
          {moment(created).add(Number(data), "days").format("dddd Do MMM YYYY")}
        </>
      );
    } else {
      return moment(created).add(10, "days").format("dddd Do MMM YYYY");
    }
  }

  const groupData = verifyresult?.data?.order?.order_items?.reduce(
    (acc, obj) => {
      const key = obj.estimated_delivery;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    },
    {},
  );

  function getShippingStep(thisData) {
    const values = thisData?.split(",");
    if (values?.some((part) => part.includes("arrived"))) {
      return true;
    } else if (values?.some((part) => part.includes("departed"))) {
      return true;
    } else if (thisData.includes("out_for_delivery")) {
      return true;
    } else {
      return false;
    }
  }

  function getShippingStep1(thisData) {
    const values = thisData?.split(",");
    if (values?.some((part) => part.includes("arrived"))) {
      return true;
    } else if (values?.some((part) => part.includes("departed"))) {
      return true;
    } else if (thisData.includes("out_for_delivery")) {
      return true;
    } else {
      return false;
    }
  }

  const [isExpand, setExpand] = useState("");

  function openTracking(data) {
    setExpand(data);
  }

  const storIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12];
  function functionIdLink(id, pid, store_id) {
    if (storIds?.includes(Number(store_id))) {
      return pid;
    } else {
      return id;
    }
  }
  function productTitle(title) {
    return title
      ?.replace(/[^A-Za-z0-9]/g, " ")
      ?.replace(/[^\w\s.,]/gi, " ")
      ?.replace(/ /g, "-");
  }

  function getProcessing(status, arived, departed) {
    const processingState = [
      "dispatched",
      "arrived_in_US",
      "departed_from_US",
      "arrived_in_UK",
      "departed_from_UK",
      "arrived_in_IN",
      "departed_from_IN",
      "arrived_in_AE",
      "departed_from_AE",
      "out_for_delivery",
      "delivered",
    ];
    const toFindArray = status?.split(",");
    if (toFindArray?.includes(arived)) {
      return true;
    } else if (toFindArray?.includes(departed)) {
      return true;
    } else {
      return processingState?.some((item) => toFindArray?.includes(item));
    }
  }

  function getDispatched(status, arived, departed) {
    const processingState = [
      "arrived_in_US",
      "departed_from_US",
      "arrived_in_UK",
      "departed_from_UK",
      "arrived_in_IN",
      "departed_from_IN",
      "arrived_in_AE",
      "departed_from_AE",
      "out_for_delivery",
      "delivered",
    ];
    const toFindArray = status?.split(",");

    if (toFindArray?.includes(arived)) {
      return true;
    } else if (toFindArray?.includes(departed)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  function getShipping(status) {
    const processingState = ["out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    return processingState.some((item) => toFindArray?.includes(item));
  }

  function getShipping2(status, curent) {
    const processingState = ["out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    if (status?.split(",")?.includes(curent)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  function getShipping3(status, curent) {
    const processingState = [
      "out_for_delivery",
      "delivered",
      "arrived_in_uae",
      "departed_from_uae",
    ];
    const toFindArray = status?.split(",");
    if (status?.split(",")?.includes(curent)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  function getitesmData(data) {
    return (
      <div className="op-section">
        <div
          className="op-card"
          style={{ ackground: "#fff0", border: "none", padding: 0 }}
        >
          {groupData &&
            Object?.entries(groupData).map(([group, groupItems]) => (
              <div
                key={group}
                style={{
                  border: "1px solid #eee",
                  borderRadius: "10px",
                  padding: "15px",
                  background: "#efefef3b",
                  marginBottom: "15px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    paddingBottom: "10px",
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 500 }}>
                    Estimated Delivery by&nbsp;
                    {getDeliverydays(group, data?.createdAt)}
                  </div>
                  <div style={{ fontSize: "14px", fontWeight: 500 }}>
                    Items: {groupItems?.length}
                  </div>
                </div>

                <div className="op-item-section" style={{ display: "block" }}>
                  {groupItems?.map((items, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "15px",
                        background: "#fff",
                        marginBottom: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "20px",
                          position: "relative",
                          height: "55px",
                        }}
                      >
                        {items.state !== "cancelled" && (
                          <Stepper
                            className="step-card-list"
                            size="lg"
                            sx={{
                              width: "100%",
                              position: "absolute",
                              "--StepIndicator-size": "2rem",
                              "--Step-connectorInset": "0px",
                              [`& .${stepIndicatorClasses.root}`]: {
                                borderWidth: 2,
                              },
                              [`& .${stepClasses.root}::after`]: {
                                height: 2,
                              },
                              [`& .${stepClasses.completed}`]: {
                                [`& .${stepIndicatorClasses.root}`]: {
                                  borderColor: "primary.300",
                                  // color: 'primary.300',
                                },
                                "&::after": {
                                  bgcolor: "primary.300",
                                },
                              },
                              [`& .${stepClasses.active}`]: {
                                [`& .${stepIndicatorClasses.root}`]: {
                                  border: "3px solid",
                                  borderColor: "#fff",
                                  boxShadow: (theme) =>
                                    `0 0 0 1px ${theme.vars.palette.warning[500]}`,
                                },
                              },
                              [`& .${stepClasses.disabled} *`]: {
                                color: "neutral.outlinedDisabledColor",
                              },
                            }}
                          >
                            <Step
                              className="step-item-list"
                              active={items.shipping_state == "processing"}
                              completed={getProcessing(
                                items.shipping_status,
                                `arrived_in_uae`,
                                `departed_from_uae`,
                              )}
                              orientation="vertical"
                              indicator={
                                <StepIndicator
                                  variant={
                                    getProcessing(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )
                                      ? "solid"
                                      : items.shipping_state == "processing"
                                        ? "solid"
                                        : "outlined"
                                  }
                                  color={
                                    getProcessing(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )
                                      ? "success"
                                      : items.shipping_state == "processing"
                                        ? "warning"
                                        : "neutral"
                                  }
                                >
                                  {getProcessing(
                                    items.shipping_status,
                                    `arrived_in_uae`,
                                    `departed_from_uae`,
                                  ) ? (
                                    <CheckCircleRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  ) : (
                                    <FiberManualRecordIcon
                                      className="checkthiss"
                                      style={{ fontSize: "20px" }}
                                    />
                                  )}
                                </StepIndicator>
                              }
                            >
                              <Typography
                                style={{ gap: "1px" }}
                                sx={{
                                  textTransform: "uppercase",
                                  fontWeight: "lg",
                                  fontSize: "0.7rem",
                                  letterSpacing: "0.5px",
                                  gap: "2px",
                                }}
                              >
                                Processing
                              </Typography>
                            </Step>

                            <Step
                              className="step-item-list"
                              active={items.shipping_state == "dispatched"}
                              completed={getDispatched(
                                items.shipping_status,
                                `arrived_in_uae`,
                                `departed_from_uae`,
                              )}
                              orientation="vertical"
                              indicator={
                                <StepIndicator
                                  variant={
                                    getDispatched(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )
                                      ? "solid"
                                      : items.shipping_state == "dispatched"
                                        ? "solid"
                                        : "outlined"
                                  }
                                  color={
                                    getDispatched(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )
                                      ? "success"
                                      : items.shipping_state == "dispatched"
                                        ? "warning"
                                        : "neutral"
                                  }
                                >
                                  {getDispatched(
                                    items.shipping_status,
                                    `arrived_in_uae`,
                                    `departed_from_uae`,
                                  ) ? (
                                    <CheckCircleRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  ) : (
                                    <LocalMallIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  )}
                                </StepIndicator>
                              }
                            >
                              <Typography
                                sx={{
                                  textTransform: "uppercase",
                                  fontWeight: "lg",
                                  fontSize: "0.7rem",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Procuring
                              </Typography>
                            </Step>
                            <Step
                              className="step-item-list"
                              active={getShippingStep1(items.shipping_state)}
                              completed={getShipping(items.shipping_status)}
                              orientation="vertical"
                              indicator={
                                <StepIndicator
                                  variant={
                                    getShippingStep(items.shipping_status)
                                      ? "solid"
                                      : getShipping(items.shipping_status)
                                        ? "solid"
                                        : "outlined"
                                  }
                                  color={
                                    getShipping(items.shipping_status)
                                      ? "success"
                                      : getShippingStep(items.shipping_status)
                                        ? "warning"
                                        : "neutral"
                                  }
                                >
                                  {getShipping(items.shipping_status) ? (
                                    <CheckCircleRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  ) : (
                                    <LocalShippingRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  )}
                                </StepIndicator>
                              }
                            >
                              <Typography
                                sx={{
                                  textTransform: "uppercase",
                                  fontWeight: "lg",
                                  fontSize: "0.7rem",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Shipping
                              </Typography>
                            </Step>
                            <Step
                              className="step-item-list"
                              completed={items.shipping_state == "delivered"}
                              orientation="vertical"
                              indicator={
                                <StepIndicator
                                  variant={
                                    items.shipping_state == "delivered"
                                      ? "solid"
                                      : "outlined"
                                  }
                                  color={
                                    items.shipping_state == "delivered"
                                      ? "success"
                                      : "neutral"
                                  }
                                >
                                  {items.shipping_state == "delivered" ? (
                                    <CheckCircleRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  ) : (
                                    <CheckCircleRoundedIcon
                                      style={{ fontSize: "20px" }}
                                    />
                                  )}
                                </StepIndicator>
                              }
                            >
                              <Typography
                                sx={{
                                  textTransform: "uppercase",
                                  fontWeight: "lg",
                                  fontSize: "0.7rem",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Delivered
                              </Typography>
                            </Step>
                          </Stepper>
                        )}
                      </div>
                      <div
                        className="op-item-card"
                        style={{
                          background: "#fff",
                          padding: "12px",
                          border: "none",
                        }}
                      >
                        <Link
                          to={`/product/${items.store_id}/${functionIdLink(items?.product_id, items?.pid, items?.store_id)}/${productTitle(items.title)}`}
                        >
                          <img
                            className="op-item-img"
                            style={{
                              borderRadius: "100px",
                              border: "1px solid #eee",
                            }}
                            src={items.image}
                          />
                        </Link>
                        <div className="op-item-title">
                          <Link
                            to={`/product/${items.store_id}/${functionIdLink(items?.product_id, items?.pid, items?.store_id)}/${productTitle(items.title)}`}
                          >
                            <p style={{ margin: 0 }}>
                              {items.title?.replace(/[^\w\s.,/:']/gi, " ")}
                            </p>
                          </Link>
                          <div
                            className="op-item-content"
                            style={{ padding: "5px 0px 0px 0px" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              <Tag>Condition: {items.conditions}</Tag>
                              <Tag>Qty.: {items.quantity}</Tag>
                            </div>
                          </div>
                          {items.current_variant && (
                            <div
                              style={{
                                padding: "5px 0px 0px 0px",
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              {Object.entries(items.current_variant || []).map(
                                ([key, value], index) => (
                                  <Tag style={{ fontSize: "10px" }} key={index}>
                                    <strong>{key}:</strong> {value}
                                  </Tag>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="oip-f-jc-c">
                        <div>
                          {items.state !== "cancelled" && (
                            <>
                              <IconButton
                                className="oip-f-button"
                                style={{
                                  minHeight: "30px",
                                  padding: "0px 10px 0px 10px",
                                  borderRadius: "10px",
                                }}
                                size="sm"
                                variant="outlined"
                                onClick={() =>
                                  openTracking(
                                    isExpand === `open${items.id}`
                                      ? ""
                                      : `open${items.id}`,
                                  )
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span style={{ fontSize: "13px" }}>
                                    Item Tracking
                                  </span>
                                  {isExpand === `open${items.id}` && (
                                    <ExpandLessIcon
                                      style={{ fontSize: "22px" }}
                                    />
                                  )}
                                  {isExpand !== `open${items.id}` && (
                                    <ExpandMoreIcon
                                      style={{ fontSize: "22px" }}
                                    />
                                  )}
                                </div>
                              </IconButton>

                              {isExpand === `open${items.id}` && (
                                <Stepper
                                  style={{ marginTop: "20px" }}
                                  orientation="vertical"
                                  sx={{
                                    "--Stepper-verticalGap": "1.5rem",
                                    "--StepIndicator-size": "1.5rem",
                                    "--Step-gap": "1rem",
                                    "--Step-connectorInset": "0rem",
                                    "--Step-connectorRadius": "1rem",
                                    "--Step-connectorThickness": "1.5px",
                                    "--joy-palette-success-solidBg":
                                      "var(--joy-palette-success-400)",

                                    [`& .${stepClasses.completed}`]: {
                                      "&::after": {
                                        bgcolor: "success.solidBg",
                                      },
                                    },
                                    [`& .${stepClasses.active}`]: {
                                      [`& .${stepIndicatorClasses.root}`]: {
                                        border: "2px solid",
                                        borderColor: "#fff",
                                        boxShadow: (theme) =>
                                          `0 0 0 1px ${theme.vars.palette.warning[500]}`,
                                      },
                                    },
                                    [`& .${stepClasses.disabled} *`]: {
                                      color: "neutral.softDisabledColor",
                                    },
                                    [`& .${typographyClasses["title-sm"]}`]: {
                                      textTransform: "uppercase",
                                      letterSpacing: "1px",
                                      fontSize: "10px",
                                    },
                                  }}
                                >
                                  <Step
                                    active={
                                      items.shipping_state == "processing"
                                    }
                                    completed={getProcessing(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          getProcessing(
                                            items.shipping_status,
                                            `arrived_in_uae`,
                                            `departed_from_uae`,
                                          )
                                            ? "solid"
                                            : items.shipping_state ==
                                                "processing"
                                              ? "solid"
                                              : "outlined"
                                        }
                                        color={
                                          getProcessing(
                                            items.shipping_status,
                                            `arrived_in_uae`,
                                            `departed_from_uae`,
                                          )
                                            ? "success"
                                            : items.shipping_state ==
                                                "processing"
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        {getProcessing(
                                          items.shipping_status,
                                          `arrived_in_uae`,
                                          `departed_from_uae`,
                                        ) ? (
                                          <CheckCircleRoundedIcon
                                            style={{ fontSize: "14px" }}
                                          />
                                        ) : (
                                          <span style={{ fontSize: "12px" }}>
                                            1
                                          </span>
                                        )}
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state == "processing"
                                            ? false
                                            : !getProcessing(
                                                items.shipping_status,
                                                `arrived_in_uae`,
                                                `departed_from_uae`,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          <small>Estimated 1 day</small>
                                          <br />
                                          Processing
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>

                                  <Step
                                    active={
                                      items.shipping_state == "dispatched"
                                    }
                                    completed={getDispatched(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          getDispatched(
                                            items.shipping_status,
                                            `arrived_in_uae`,
                                            `departed_from_uae`,
                                          )
                                            ? "solid"
                                            : items.shipping_state ==
                                                "dispatched"
                                              ? "solid"
                                              : "outlined"
                                        }
                                        color={
                                          getDispatched(
                                            items.shipping_status,
                                            `arrived_in_uae`,
                                            `departed_from_uae`,
                                          )
                                            ? "success"
                                            : items.shipping_state ==
                                                "dispatched"
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        {getDispatched(
                                          items.shipping_status,
                                          `arrived_in_uae`,
                                          `departed_from_uae`,
                                        ) ? (
                                          <CheckCircleRoundedIcon
                                            style={{ fontSize: "15px" }}
                                          />
                                        ) : (
                                          <span style={{ fontSize: "12px" }}>
                                            2
                                          </span>
                                        )}
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state == "dispatched"
                                            ? false
                                            : !getDispatched(
                                                items.shipping_status,
                                                `arrived_in_uae`,
                                                `departed_from_uae`,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          <small>
                                            {items.country === "AE"
                                              ? "Estimated 1-2 days"
                                              : "Estimated 2-3 days"}
                                          </small>
                                          <br />
                                          Procuring
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>

                                  <Step
                                    active={
                                      items.shipping_state === "dispatched"
                                    }
                                    completed={getDispatched(
                                      items.shipping_status,
                                      `arrived_in_uae`,
                                      `departed_from_uae`,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          items.shipping_state === "dispatched"
                                            ? "solid"
                                            : "outlined"
                                        }
                                        color={
                                          getDispatched(
                                            items.shipping_status,
                                            `arrived_in_uae`,
                                            `departed_from_uae`,
                                          )
                                            ? "success"
                                            : items.shipping_state ===
                                                "dispatched"
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        <FiberManualRecordIcon
                                          style={{ fontSize: "13px" }}
                                        />
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state == "dispatched"
                                            ? false
                                            : !getDispatched(
                                                items.shipping_status,
                                                `arrived_in_uae`,
                                                `departed_from_uae`,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          Dispatched from Supplier
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>

                                  <Step
                                    active={getShippingStep1(
                                      items.shipping_state,
                                    )}
                                    completed={getShipping(
                                      items.shipping_status,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          getShippingStep(items.shipping_status)
                                            ? "solid"
                                            : getShipping(items.shipping_status)
                                              ? "solid"
                                              : "outlined"
                                        }
                                        color={
                                          getShipping(items.shipping_status)
                                            ? "success"
                                            : getShippingStep(
                                                  items.shipping_status,
                                                )
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        {getShipping(items.shipping_status) ? (
                                          <CheckCircleRoundedIcon
                                            style={{ fontSize: "14px" }}
                                          />
                                        ) : (
                                          <span style={{ fontSize: "12px" }}>
                                            3
                                          </span>
                                        )}
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          getShippingStep1(items.shipping_state)
                                            ? false
                                            : !getShipping(
                                                items.shipping_status,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          <small>
                                            {items.country === "AE"
                                              ? "Estimated 1-2 days"
                                              : "Estimated 3-5 days"}
                                          </small>
                                          <br />
                                          Shipping and Fulfillment
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>
                                  {items.country !== "AE" && (
                                    <>
                                      <Step
                                        active={
                                          items.shipping_state ===
                                          `arrived_in_${items.country}`
                                        }
                                        completed={getShipping3(
                                          items.shipping_status,
                                          `departed_from_${items.country}`,
                                        )}
                                        indicator={
                                          <StepIndicator
                                            variant={
                                              items.shipping_state ===
                                              `arrived_in_${items.country}`
                                                ? "solid"
                                                : "outlined"
                                            }
                                            color={
                                              getShipping3(
                                                items.shipping_status,
                                                `departed_from_${items.country}`,
                                              )
                                                ? "success"
                                                : items.shipping_status
                                                      ?.split(",")
                                                      ?.includes(
                                                        `arrived_in_${items.country}`,
                                                      )
                                                  ? "warning"
                                                  : "neutral"
                                            }
                                          >
                                            <FiberManualRecordIcon
                                              style={{ fontSize: "13px" }}
                                            />
                                          </StepIndicator>
                                        }
                                      >
                                        <div>
                                          <Button
                                            disabled={
                                              items.shipping_state ===
                                              `arrived_in_${items.country}`
                                                ? false
                                                : !getShipping3(
                                                    items.shipping_status,
                                                    `departed_from_${items.country}`,
                                                  )
                                            }
                                            variant="light"
                                            className="shipping-step-card"
                                          >
                                            <div level="title-sm">
                                              Arrived in {items.country}{" "}
                                              warehouse
                                            </div>
                                          </Button>
                                        </div>
                                      </Step>

                                      <Step
                                        active={
                                          items.shipping_state ===
                                          `departed_from_${items.country}`
                                        }
                                        completed={getShipping3(
                                          items.shipping_status,
                                          `arrived_in_uae`,
                                        )}
                                        indicator={
                                          <StepIndicator
                                            variant={
                                              items.shipping_state ===
                                              `departed_from_${items.country}`
                                                ? "solid"
                                                : "outlined"
                                            }
                                            color={
                                              getShipping3(
                                                items.shipping_status,
                                                `arrived_in_uae`,
                                              )
                                                ? "success"
                                                : items.shipping_status
                                                      ?.split(",")
                                                      ?.includes(
                                                        `departed_from_${items.country}`,
                                                      )
                                                  ? "warning"
                                                  : "neutral"
                                            }
                                          >
                                            <FiberManualRecordIcon
                                              style={{ fontSize: "13px" }}
                                            />
                                          </StepIndicator>
                                        }
                                      >
                                        <div>
                                          <Button
                                            disabled={
                                              items.shipping_state ===
                                              `departed_from_${items.country}`
                                                ? false
                                                : !getShipping3(
                                                    items.shipping_status,
                                                    `arrived_in_uae`,
                                                  )
                                            }
                                            variant="light"
                                            className="shipping-step-card"
                                          >
                                            <div level="title-sm">
                                              Departed from {items.country}{" "}
                                              warehouse
                                            </div>
                                          </Button>
                                        </div>
                                      </Step>
                                    </>
                                  )}
                                  <Step
                                    active={
                                      items.shipping_state === `arrived_in_uae`
                                    }
                                    completed={getShipping2(
                                      items.shipping_status,
                                      `departed_from_uae`,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          items.shipping_state ===
                                          `arrived_in_uae`
                                            ? "solid"
                                            : "outlined"
                                        }
                                        color={
                                          getShipping2(
                                            items.shipping_status,
                                            `departed_from_uae`,
                                          )
                                            ? "success"
                                            : items.shipping_status
                                                  ?.split(",")
                                                  ?.includes(`arrived_in_uae`)
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        <FiberManualRecordIcon
                                          style={{ fontSize: "13px" }}
                                        />
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state ===
                                          `arrived_in_uae`
                                            ? false
                                            : !getShipping2(
                                                items.shipping_status,
                                                `departed_from_uae`,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          Arrived in UAE warehouse
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>

                                  <Step
                                    active={
                                      items.shipping_state ===
                                      `departed_from_uae`
                                    }
                                    completed={getShipping(
                                      items.shipping_status,
                                    )}
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          items.shipping_state ===
                                          `departed_from_uae`
                                            ? "solid"
                                            : "outlined"
                                        }
                                        color={
                                          getShipping(items.shipping_status)
                                            ? "success"
                                            : items.shipping_status
                                                  ?.split(",")
                                                  ?.includes(
                                                    `departed_from_uae`,
                                                  )
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        <FiberManualRecordIcon
                                          style={{ fontSize: "13px" }}
                                        />
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state ===
                                          `departed_from_uae`
                                            ? false
                                            : !getShipping(
                                                items.shipping_status,
                                              )
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          Departed from UAE warehouse
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>

                                  <Step
                                    active={
                                      items.shipping_state ===
                                      `out_for_delivery`
                                    }
                                    completed={
                                      items.shipping_state === `delivered`
                                    }
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          items.shipping_state ===
                                          `out_for_delivery`
                                            ? "solid"
                                            : items.shipping_state ===
                                                `delivered`
                                              ? "solid"
                                              : "outlined"
                                        }
                                        color={
                                          items.shipping_state === `delivered`
                                            ? "success"
                                            : items.shipping_state ===
                                                `out_for_delivery`
                                              ? "warning"
                                              : "neutral"
                                        }
                                      >
                                        {items.shipping_state ===
                                        `delivered` ? (
                                          <CheckCircleRoundedIcon
                                            style={{ fontSize: "14px" }}
                                          />
                                        ) : (
                                          <span style={{ fontSize: "12px" }}>
                                            4
                                          </span>
                                        )}
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state ===
                                          `out_for_delivery`
                                            ? false
                                            : items.shipping_state !==
                                              `delivered`
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          Out for delivery
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>
                                  <Step
                                    completed={
                                      items.shipping_state == "delivered"
                                    }
                                    indicator={
                                      <StepIndicator
                                        variant={
                                          items.shipping_state == "delivered"
                                            ? "solid"
                                            : "outlined"
                                        }
                                        color={
                                          items.shipping_state == "delivered"
                                            ? "success"
                                            : "neutral"
                                        }
                                      >
                                        {items.shipping_state == "delivered" ? (
                                          <CheckCircleRoundedIcon
                                            style={{ fontSize: "13px" }}
                                          />
                                        ) : (
                                          <span style={{ fontSize: "12px" }}>
                                            5
                                          </span>
                                        )}
                                      </StepIndicator>
                                    }
                                  >
                                    <div>
                                      <Button
                                        disabled={
                                          items.shipping_state != "delivered"
                                        }
                                        variant="light"
                                        className="shipping-step-card"
                                      >
                                        <div level="title-sm">
                                          <small>
                                            {items.country === "AE"
                                              ? "Estimated 1-2 days"
                                              : "Estimated 2-3 days"}
                                          </small>
                                          <br />
                                          Delivered
                                        </div>
                                      </Button>
                                    </div>
                                  </Step>
                                </Stepper>
                              )}
                            </>
                          )}
                        </div>
                        <div className="oip-f-status">
                          {items.state === "cancelled" ? (
                            <div
                              className="alert alert-danger"
                              style={{
                                whiteSpace: "normal",
                                marginBottom: "10px",
                                textTransform: "uppercase",
                                padding: 0,
                                border: "none",
                                background: "#fff0",
                                fontSize: "0.8rem",
                              }}
                            >
                              Item has been cancelled
                            </div>
                          ) : (
                            <>
                              {items.delivered_on && (
                                <>
                                  {items.shipping_state === "delivered" && (
                                    <div
                                      className="alert alert-info"
                                      style={{
                                        whiteSpace: "normal",
                                        marginBottom: "10px",
                                        textTransform: "uppercase",
                                        padding: 0,
                                        border: "none",
                                        background: "#fff0",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      <span style={{ fontWeight: 400 }}>
                                        {t("DELIVERED ON")}&nbsp;
                                        {moment(items.delivered_on).format(
                                          "Do MMM YYYY HH:mm",
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </>
                              )}
                              {items.shipping_state !== "delivered" && (
                                <div
                                  className="alert alert-info"
                                  style={{
                                    whiteSpace: "normal",
                                    marginBottom: "10px",
                                    textTransform: "uppercase",
                                    padding: 0,
                                    border: "none",
                                    background: "#fff0",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  <span>
                                    {items.shipping_state?.replace(/_/g, " ")}
                                  </span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
  return (
    <>
      <HelmetComponent title={"Track order"} metaTitle={Host?.metaTitle} />

      <div className="Account-page tabel_cards">
        <br />
        <br />
        <div
          className="row"
          style={{ justifyContent: "center", margin: "0px", padding: "0px" }}
        >
          <div className="col-md-10">
            <div
              className="row"
              style={{
                justifyContent: "center",
                width: "100%",
                margin: "0px",
                padding: "0px",
              }}
            >
              <div className="col-md-6">
                <div style={{ width: "100%", padding: "0px" }}>
                  {findresult?.error?.data?.error && (
                    <div
                      className="alert alert-danger"
                      style={{
                        textAlign: "center",
                        fontSize: "14px",
                        padding: "10px",
                        border: "none",
                      }}
                    >
                      {findresult?.error?.data?.error}
                    </div>
                  )}
                  {verifyresult?.error?.data?.error && (
                    <div
                      className="alert alert-danger"
                      style={{
                        textAlign: "center",
                        fontSize: "14px",
                        padding: "10px",
                        border: "none",
                      }}
                    >
                      {verifyresult?.error?.data?.error}
                    </div>
                  )}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      sx={{
                        width: 86,
                        height: 86,
                        borderRadius: "50%",
                        background: "#fff7f2",
                        border: "1px solid #ffe1d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                      }}
                    >
                      <LocalShippingOutlinedIcon
                        sx={{
                          fontSize: 38,
                          color: "#ff7043",
                        }}
                      />
                    </Box>
                  </div>

                  {!verifyresult?.data?.order && (
                    <h3
                      style={{
                        textAlign: "center",
                        padding: "20px 0px 20px 0px",
                        fontSize: "1.4rem",
                        fontWeight: 400,
                      }}
                    >
                      {t("Track your order")}{" "}
                    </h3>
                  )}
                  <p style={{ textAlign: "center" }}>
                    Enter your order number and the email used at checkout. We
                    will send an OTP to your email. Enter the OTP to view your
                    order status.
                  </p>

                  {isLoginCard && (
                    <form onSubmit={handleSubmit(trackOrder)}>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LfD62EnAAAAAJ83k0BznR8m_cXInxBFjtTokspL"
                      />
                      <div
                        className="row"
                        style={{ margin: "0px", padding: "0px" }}
                      >
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>{t("Order Number")} </label>
                            <input
                              style={{ background: "#f3f3f3", height: "60px" }}
                              type="text"
                              className="form-control"
                              id="order_number"
                              aria-invalid={
                                errors.order_number ? "true" : "false"
                              }
                              {...register("order_number", { required: true })}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>{t("email")} </label>
                            <input
                              style={{ background: "#f3f3f3", height: "60px" }}
                              type="email"
                              className="form-control"
                              id="email"
                              aria-invalid={errors.email ? "true" : "false"}
                              {...register("email", { required: true })}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 Header-signin-button">
                          <div className="form-group">
                            <Button
                              disabled={findresult.isLoading}
                              style={{
                                height: "55px",
                                background: Host?.bgColor,
                                color: Host?.buttonColor,
                                width: "100%",
                                textTransform: "capitalize",
                              }}
                              variant="info"
                              type="submit"
                            >
                              <span style={fontFamily}>
                                {findresult.isLoading ? (
                                  <Loader />
                                ) : (
                                  t("submit")
                                )}
                              </span>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                  {isOtpCard && (
                    <form onSubmit={handleSubmit2(loginWithOtp)}>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LfD62EnAAAAAJ83k0BznR8m_cXInxBFjtTokspL"
                      />
                      <div className="col-md-12">
                        <div
                          className="form-group"
                          style={{
                            textAlign: "center",
                            padding: "15px 0px 15px 0px",
                          }}
                        >
                          <label style={{ textAlign: "center" }}>
                            {t("Enter your OTP")}{" "}
                          </label>
                          <OtpInput
                            inputStyle="inputStyle"
                            containerStyle="otp otp-verify"
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={
                              <div style={{ padding: "5px" }}></div>
                            }
                            id="code"
                            renderInput={(props) => <input {...props} />}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 Header-signin-button">
                        <div
                          className="form-group"
                          style={{ textAlign: "center" }}
                        >
                          <Button
                            type="submit"
                            disabled={verifyresult?.isLoading}
                            variant="info"
                            style={{
                              height: "55px",
                              background: Host?.bgColor,
                              color: Host?.buttonColor,
                              width: "auto",
                              textTransform: "capitalize",
                            }}
                          >
                            <span style={fontFamily}>
                              {verifyresult?.isLoading ? (
                                <Loader />
                              ) : (
                                t("submit")
                              )}
                            </span>
                          </Button>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>

              {verifyresult?.data?.order && (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div className="col-md-12">
                      <h3
                        style={{
                          textAlign: "center",
                          padding: "20px 0px 20px 0px",
                          fontSize: "1.5rem",
                          fontWeight: 400,
                        }}
                      >
                        {t("Order Details")}{" "}
                      </h3>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "left",
                      flexWrap: "wrap",
                      flexDirection: "column-reverse",
                    }}
                  >
                    <div className="col-md-8">
                      {getitesmData(verifyresult?.data?.order)}
                    </div>
                    <div className="col-md-4">
                      <div
                        className="op-card-header pg-m-center"
                        style={{
                          textAlign: "right",
                          border: "1px solid #eee",
                          borderRadius: "10px",
                          padding: "15px",
                          background: "#efefef3b",
                        }}
                      >
                        <div
                          className="op-o-info"
                          style={{ fontSize: "1.1rem" }}
                        >
                          <div style={{ marginBottom: "6px" }}>
                            <span style={{ fontWeight: 500 }}>
                              Order Number:&nbsp;
                            </span>
                            {verifyresult?.data?.order?.order_number}
                          </div>
                          <div style={{ marginBottom: "6px" }}>
                            <span style={{ fontWeight: 500 }}>
                              Total Items:&nbsp;
                            </span>
                            {verifyresult?.data?.order?.order_items?.length}
                          </div>
                        </div>
                        <div
                          className="op-o-info"
                          style={{ fontSize: "1.1rem" }}
                        >
                          <div style={{ marginBottom: "6px" }}>
                            <span style={{ fontWeight: 500 }}>
                              Order Status:&nbsp;
                            </span>
                            {verifyresult?.data?.order?.states ===
                            "cancelled" ? (
                              <span className="badge badge-danger">
                                Cancelled
                              </span>
                            ) : (
                              <>
                                {verifyresult?.data?.order?.status ? (
                                  <span className="badge badge-success">
                                    Confirmed
                                  </span>
                                ) : (
                                  <span className="badge badge-warning">
                                    Payment pending
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                          <div style={{ marginBottom: "6px" }}>
                            <span style={{ fontWeight: 500 }}>
                              {t("order_placed_on")}:&nbsp;
                            </span>{" "}
                            {moment(
                              verifyresult?.data?.order?.createdAt,
                            ).format("MMM Do YYYY")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrackOrder;
